function getTargetResource(region: string, instanceId: string, destinationRelay?: string) {
    const url = new URL(`https://${region}.console.aws.amazon.com/connect/federate/${instanceId}`);
    if (destinationRelay) url.searchParams.set("destination", destinationRelay);
    return url.toString();
}

export function getAmazonConnectLoginUrl(
    identityProvider: { loginUrl: string; searchParamName: string },
    region: string,
    instanceId: string,
    destinationRelay?: string,
) {
    const url = new URL(identityProvider.loginUrl);
    url.searchParams.set(identityProvider.searchParamName, getTargetResource(region, instanceId, destinationRelay));
    return url.toString();
}
